export default "__VITE_ASSET__DprKXmBZ__"